module.exports = __webpack_public_path__ + "img/image5.f9628c7d.png";